<script>
import InputText from './InputText.vue'
import Recaptcha from '../../common/components/Recaptcha.vue'
import $ from "jquery";

export default {
  name: 'PageLandingCereal',

  components: {
    InputText,
    Recaptcha,
  },

  props: {
    optin: {
      type: String,
      default: '',
    },
    hasmezzo: {
      type: String,
      default: '0',
    },
  },

  data() {
    return {
      isPosted: false,
      captchaError: false,
      form: {
        product: '',
        lastname: '',
        company: '',
        email: '',
        phone: '',
        address: '',
        zipcode: '',
        town: '',
        message: '',
        captcha: '',
        mention: '',
        mezzo: this.hasmezzo,
      },
      formEl: null,
    }
  },

  computed: {
    showForm() {
      return !this.isPosted
    },
    showConfirmation() {
      return this.isPosted
    },
  },

  mounted() {
    this.formEl = this.$el.querySelector('form')
    this.isPosted = this.formEl.querySelector('.webform-confirmation') !== null

    $(document).ready(function () {
      window.dataLayer = window.dataLayer || [];
      var itemToPush = {};
      // Page title (pagename)
      var H1 = jQuery('h1');
      if (H1.length) {
        itemToPush['pagename'] = H1.text().replace(/["+?!]/g,'').replace(/[#_', ]/g,'_').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      }
      itemToPush['pagetype'] = 'Landing page';
      itemToPush['event'] = "page_load";
      window.dataLayer.push(itemToPush);
    });
  },

  methods: {
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
      this.captchaError = true
    },
    onCaptchaVerified(token) {
      this.$refs.recaptcha.reset()
      this.form.captcha = token
      this.submitForm()
    },
    checkRecaptcha() {
      this.captchaError = false
      this.$refs.recaptcha.execute()
    },
    submitForm() {
      this.$validator
        .validateAll()
        .then((result) => {
          result && this.form.captcha.length > 0 ? this.sendForm() : null
        })
        .catch((e) => {
          console.log(e)
        })
    },
    sendForm() {
      const formData = {
        event: 'form_confirmation',
        form_type: 'Landing_cereal',
        form_name: this.$el.querySelector('h1.title').textContent,
        event_detail: this.form.product,
      }

      for (let [key, value] of Object.entries(this.form)) {
        let input = this.formEl.querySelector(`[name='${key.toLowerCase()}']`)
        if (input) {
          switch (key) {
            case 'mention':
              input.value = value ? this.optin : ''
              break
            case 'acceptance':
              input.value = 'Envoyer mon email'
              break
            default:
              input.value = value
              break
          }
        }
      }

      this.updateDatalayer(formData)
      this.formEl.submit()
    },
    updateDatalayer(formData) {
      // regex used to get only text part from the title with removing useless special char
      formData.form_name = formData.form_name
        .trim()
        .replace(/["+?!]/g, '')
        .replace(/[#_', ]/g, '_')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')

      // Then push it to the data layer
      window.dataLayer.push(formData)
    },
  },
}
</script>

<style scoped lang="sass">
@import ../../common/styles/mixins
@import ../../common/styles/settings
@import PageLandingCereal
@import LandingForm
</style>
